import React from 'react';
import './CSS/Footer.css'

const Footer = () => {
    return (
      <div className="Footer-area">
        <h1>This is Footer Section</h1>
        <p>© Copyright 2021 giftpoint.com</p>
      </div>
    );
};

export default Footer;
